import React, { useRef, useEffect } from 'react';
import { ScrollView } from 'react-native';
import BottomSheet from '@gorhom/bottom-sheet';
import { PortalProvider, PortalHost } from '@gorhom/portal';
import Toast from 'react-native-toast-message';
import { FileType, PlaybackState, usePlaybackStateStore, } from '@annunciate/core';
import { PlaybackEventEmitter, PlaybackEvent, } from '@annunciate/core';
import { Player, useProgressSynchronizer, useAnimatedPlayerIndex, usePlayerUtils, View, playerRef as bottomSheetRef, useAppTransitionListener, } from '@annunciate/ui';
import { useResumeContent, useTrackPlayer, useTrackPlayerProgress, } from '@annunciate/player';
import { useUserQuery } from '@annunciate/query';
import { useMiniplayerHeight } from '../hooks/useMiniplayerHeight';
import { rootScrollViewRef, rootScrollMap } from '../utils';
const setState = usePlaybackStateStore.getState().setState;
export const RootView = ({ children }) => {
    const initialPlayerIndex = useRef(usePlaybackStateStore.getState().getInitialPlayerIndex());
    const indexRef = useRef(initialPlayerIndex.current);
    const animatedPlayerIndex = useAnimatedPlayerIndex();
    const { snapPoints, playing, onSheetChange, onToggleSheet, } = usePlayerUtils();
    useUserQuery();
    useTrackPlayer();
    useTrackPlayerProgress();
    useProgressSynchronizer();
    useAppTransitionListener();
    useResumeContent();
    useEffect(() => {
        const onPlaybackStartListener = async ({ content }) => {
            const fileType = content?.asset?.type;
            const shouldFullyExpand = (fileType === FileType.VIDEO || fileType === FileType.EBOOK);
            const shouldDismiss = !(fileType && [FileType.AUDIO, FileType.VIDEO, FileType.EBOOK].includes(fileType));
            if (shouldDismiss) {
                bottomSheetRef.current?.close();
            }
            else if (indexRef.current === -1 && !shouldFullyExpand) {
                bottomSheetRef.current?.snapToPosition(1);
                bottomSheetRef.current?.collapse();
            }
            else if (shouldFullyExpand) {
                bottomSheetRef.current?.expand({ duration: 500 });
            }
        };
        const onPlaybackStopListener = async ({ next } = {}) => {
            if (playing && playing.id !== next?.id) {
                setState(playing.id, PlaybackState.NONE);
            }
            if (!next)
                bottomSheetRef.current?.close();
        };
        const onError = async ({ message, }) => {
            Toast.show({
                type: 'error',
                text1: 'Uh oh!',
                text2: message,
            });
        };
        PlaybackEventEmitter.on(PlaybackEvent.START, onPlaybackStartListener);
        PlaybackEventEmitter.on(PlaybackEvent.STOP, onPlaybackStopListener);
        PlaybackEventEmitter.on(PlaybackEvent.ENTITLEMENT_ERROR, onError);
        PlaybackEventEmitter.on(PlaybackEvent.UNKOWN_ERROR, onError);
        return () => {
            PlaybackEventEmitter.off(PlaybackEvent.START, onPlaybackStartListener);
            PlaybackEventEmitter.off(PlaybackEvent.STOP, onPlaybackStopListener);
            PlaybackEventEmitter.off(PlaybackEvent.ENTITLEMENT_ERROR, onError);
            PlaybackEventEmitter.off(PlaybackEvent.UNKOWN_ERROR, onError);
        };
    }, []);
    const bottomInset = useMiniplayerHeight();
    return (React.createElement(PortalProvider, null,
        React.createElement(ScrollView, { ref: rootScrollViewRef, onScroll: (event) => {
                rootScrollMap[window.location.pathname] =
                    event.nativeEvent.contentOffset.y;
            }, scrollEventThrottle: 100, style: {
                height: `calc(100vh - var(--nav-bar-height) - var(--mini-player-height))`,
            } }, children),
        React.createElement(BottomSheet, { ref: bottomSheetRef, snapPoints: snapPoints, index: initialPlayerIndex.current, bottomInset: bottomInset * -1, handleComponent: null, enableDynamicSizing: false, enablePanDownToClose: false, onChange: (index) => onSheetChange(index, indexRef), animatedIndex: animatedPlayerIndex, backgroundComponent: View, containerStyle: { zIndex: 1020 } },
            React.createElement(Player, { playing: playing, position: animatedPlayerIndex, onTogglePlayer: () => onToggleSheet(indexRef.current, bottomSheetRef.current) })),
        React.createElement(PortalHost, { name: "modal" })));
};
//# sourceMappingURL=RootView.js.map